import { z } from "zod";

export const professionalRegistrationSchema = z.object({
  name: z
    .string()
    .min(1, "Nome completo é obrigatório")
    .transform((v) => v.trim()),
  email: z.string().email("Por favor, insira um e-mail válido"),
  password: z
    .string()
    .min(8, "A senha deve ter pelo menos 8 caracteres"),
  healthAreaId: z.string().min(1, "Selecione sua área da saúde"),
});

export const healthAreaOnlySchema = z.object({
  healthAreaId: z.string().min(1, "Selecione sua área da saúde"),
});

export type ProfessionalRegistrationForm = z.infer<typeof professionalRegistrationSchema>;
export type HealthAreaOnlyForm = z.infer<typeof healthAreaOnlySchema>;


